//  THIS IS AN PLACEHOLDER FILE THAT WILL BE REPLACED BY THE FILES IN THE ENVIRONMENT FOLDER
export interface ApplicationConfig {
  companyName: string;
  appName: string;
  companySlogan: string;
  baseUrl: string;
  maxTicketsPerRelation: number;
  recentTicketsCount: number;
  textMaxCharacterCount: number;
  view: {
    portal:{
      questions: boolean,
      manual: boolean,
      chat: boolean,
      facebook: boolean,
      whatsapp: boolean,
      phone: boolean,
      text:{
        manual: string,
      }
    }
  },
  support: {
    manual_url: string,
    textMinCharacterCount: number,
    needHelpText: string;
    contact: {
      whatsapp: string;
      whatsapp_url: string;
      phone: string;
      facebook: string;
      chat: string;
      url: string;
    }
  };
  bank_account: string;
  livetv_url: string;
  trustpilot_url: string;
  google_reviews_url: string;
}

export const config: ApplicationConfig = {
  companyName: '',
  appName: '',
  companySlogan: '',
  baseUrl: '/api/v2/mijn-omgeving',
  recentTicketsCount: 5,
  maxTicketsPerRelation: 20,
  textMaxCharacterCount: 2000,
  view: {
    portal:{
      questions: false,
      manual: false,
      chat: false,
      facebook: false,
      whatsapp: false,
      phone: false,
      text:{
        manual: '',
      }
    },
  },
  support: {
    manual_url: '',
    textMinCharacterCount: 10,
    needHelpText: '',
    contact: {
      whatsapp: '',
      whatsapp_url:'',
      phone: '',
      facebook: '',
      chat: '',
      url: '',
    }
  },
  bank_account: '',
  livetv_url: '',
  trustpilot_url: '',
  google_reviews_url: ''
}
